// src/app/admin/views/company/add-external-user/add-external-user.component.ts

import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-add-external-user',
  templateUrl: './add-external-user.component.html',
  styleUrls: ['./add-external-user.component.scss']
})
export class AddExternalUserComponent {

  @Input() type: string | undefined; // Type = SIGNUP (OUT SIDE) | CREATE (INSIDE through ADMIN) | UPDATE (update USER);
  @Input() data: any; // For user update data
  @Input() ExternalType : any
  @Input() company : any
  @Output() updatedData = new EventEmitter<any>();
  @Input() addCompany : boolean = false
  currentOU:any;
  myForm: FormGroup | any;
  signupSuccess = false;
  message: undefined | string;
  city: Array<Location | any> = [];
  roles: Array<any> = [];
  translator:TranslatorPipe = new TranslatorPipe()
  ous: Array<OrganizationUnit> = [];
  filtredOus: Array<OrganizationUnit> = [];
  selectedOus: Array<OrganizationUnit> | any = [];
  selectedOusIds: Array<String> | any = [];


  gender = [{ label: this.translate('male') }, { label: this.translate('feminine') }];

  addOu: boolean = false;

  companies : any
  filteredCompanies : any =[]
  

  ngOnInit() {
    if (this.type == 'UPDATE' || this.type == 'CREATE') {
      Promise.all([this.getRoles(), this.getCity(), this.getCompanyData()]).then(
        (e) => {
        }
      );
    } else {
      Promise.all([this.getCity()]).then((e) => {
      });
    }
    this.constructForObject();
  }

  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  async getCompanyData(){
    let res = await this.dataService.getData('company/');
    this.companies = res.data
    
  
  }
  

  filterCountry(event : any) {
    let filtered: any[] = [];
    let query = event.query;

    filtered = this.companies.filter((company:any)=> 
      company.name.toLowerCase().includes(query)
  );

  this.filteredCompanies = [...filtered]

}

  constructForObject() {
    console.log(this.data?.name);
    if (this.type == 'UPDATE' || this.type == 'CREATE') {
      this.myForm = this.formBuilder.group({
        fName: [
          this.data?.name?.first,
          [Validators.required, Validators.minLength(3)],
        ],
        mName: [this.data?.name?.middle, [Validators.required]],
        lName: [
          this.data?.name?.last,
          [Validators.required, Validators.minLength(3)],
        ],
        email: [this.data?.email, [Validators.required, Validators.email]],
        phone: [
          this.data?.phone,
          [
            Validators.required,
            Validators.pattern(
              '^[+]?[0]?[0]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$'
            ),
          ],
        ],
        // national_id: [
        //   this.data?.national_id,
        //   [Validators.required, Validators.pattern('^[0-9]{10}$')],
        // ],
        gender: [{ label: this.data?.gender }, [Validators.required]],
      });
    }
  }

  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private cdr:ChangeDetectorRef
  ) {
    if (this.type == 'SIGNUP') {
      this.myForm = this.formBuilder.group({
        fName: [null, [Validators.required, Validators.minLength(3)]],
        mName: [null, [Validators.required]],
        lName: [null, [Validators.required, Validators.minLength(3)]],
        email: ['', [Validators.required, Validators.email]],
        phone: [
          null,
          [
            Validators.required,
            Validators.pattern(
              '^[+]?[0]?[0]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$'
            ),
          ],
        ],
        // national_id: [
        //   null,
        //   [Validators.required, Validators.pattern('^[0-9]{10}$')],
        // ],
        gender: [null, [Validators.required]],
        location: [null, [Validators.required]],
        company : [null]
      });
    } else {
      this.myForm = this.formBuilder.group({
        fName: [null, [Validators.required, Validators.minLength(3)]],
        mName: [null, [Validators.required]],
        lName: [null, [Validators.required, Validators.minLength(3)]],
        email: ['', [Validators.required, Validators.email]],
        phone: [
          null,
          [
            Validators.required,
            Validators.pattern(
              '^[+]?[0]?[0]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$'
            ),
          ],
        ],
        // national_id: [
        //   null,
        //   [Validators.required, Validators.pattern('^[0-9]{10}$')],
        // ],
        gender: [null, [Validators.required]],
        company : [null]
      });
    }
  }

  async onSubmit() {
    // handle form submission
    this.myForm;
    let email, active;
    let data: any = this.createLoginObject(this.myForm.value);
    if (this.type == 'SIGNUP') delete data.role;
    let response: any;
    switch (this.type) {
      case 'UPDATE':
        data._id = this.data._id;
        email = data.email;
        active = this.data.active;
        // data.role = [data.role];
        data.active = this.data.active;
        if (this.data?.email == data.email) delete data.email;
        response = await this.dataService.postData('user', data, 'PUT', false);
        break;
      case 'SIGNUP':
        response = await this.dataService.postData('user/register', data);
        break;
      case 'CREATE':
        response = await this.dataService.postData('user/create', data);
        break;
      default:
        return;
    }
    if (response.error == true) {
      this.message = response.msg;
    } else {
      this.message = response.msg;
      this.signupSuccess = true;
    }

    if (this.type == 'UPDATE' && !response.error) {
      this.data = data;
      let obj = JSON.parse(JSON.stringify(this.data));
      obj.email = email;
      obj.active = active;
      this.updatedData.emit(obj);
    }

    this.updatedData.emit(true);
  }

  createLoginObject(data: any) {
    console.log('data from File', data);


    let trainerObject : any = { status : true , role : 'trainer' , company: this.company ? this.company : '6637b2662ba03d1ffddfd2b6'}
    //company check
    if(data.company && data.company != '' && data.company !=null){
      if(typeof data.company === 'object'){
        this.company = data.company._id;
        trainerObject = { status : true , role : 'trainer' , company: this.company}
      } else if (typeof data.company === 'string') {
        this.company = data.company;
        trainerObject = { status : true , role : 'trainer' , companyName : this.company }
      }
    }




    

    return {
      name: {
        first: data.fName,
        middle: data.mName,
        last: data.lName,
      },
      email: data.email,
      phone: data.phone,
      national_id: data.national_id,
      gender: data.gender.label,
      // location: data.location,
      // ou: this.selectedOusIds,
      // role: data.role,
      externalUser : this.ExternalType == 'Coordinator' ? { status : true , role : 'Coordinator', company : this.company ? this.company : '6637b2662ba03d1ffddfd2b6'} : trainerObject ,
      active: {
        status: false,
        reason: 'NEW ACCOUNT',
        activationDate: null,
      },
    };
  }

  async getRoles() {
    try {
      let res = await this.dataService.getData('role');
      if (!res.error) {
        this.roles = res.data.map((location: any) => {
          return {
            value: location._id,
            label: location.name,
          };
        });
        console.log('this.role', this.roles);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getCity() {
    try {
      let res = await this.dataService.getData('location');
      if (!res.error) {
        this.city = res.data.map((location: any) => {
          return {
            value: location._id,
            label: location.name,
            icon: 'pi pi-map-marker',
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
}
